import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import {
    InstitutionCreateDepartmentPersonnelBreadcrumbs,
    InstitutionDepartmentPersonnelBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as InstitutionActions from "../../../actions/institution";
import * as NavigationActions from "../../../actions/navigation";
import * as PersonnelRoleActions from "../../../actions/personnelRole";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    DatePickerFormInputFabric,
    SelectFormInput,
    TextFormInput,
} from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning,
} from "../../../helpers/alert";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import { InstitutionSubMenu } from "../../../helpers/subMenuHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import {
    IPersonnelRoleReduxFormState,
    initialPersonnelRoleState,
} from "../../../reducers/reactReduxForms/personnelRole";

import "./InstitutionDepartmentPersonnelEditPage.scss";

interface IInstitutionDepartmentPersonnelEditPageParams {
    institutionId: number;
    departmentId: number;
    personnelRoleId: number;
}

interface IInstitutionDepartmentPersonnelEditPageProps
    extends IRouterProps<IInstitutionDepartmentPersonnelEditPageParams> {
    form: Dtos.PersonnelRole & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IPersonnelRoleReduxFormState;

    institutionId: number;
    departmentId: number;
    personnelRoleId: number;

    // From state
    department: Dtos.Department;
    personnelRole: Dtos.PersonnelRole;
    institution: Dtos.Institution;
    lookups: Dtos.Lookup[];

    loadingInstitution: boolean;
    loadInstitutionSuccess: boolean;
    loadInstitutionFailure: boolean;
    loadInstitutionErrorCode: string;

    loadingPersonnelRole: boolean;
    loadPersonnelRoleSuccess: boolean;
    loadPersonnelRoleFailure: boolean;
    loadPersonnelRoleErrorCode: string;

    savingPersonnelRole: boolean;
    savePersonnelRoleSuccess: boolean;
    savePersonnelRoleFailure: boolean;

    creatingPersonnelRole: boolean;
    createPersonnelRoleSuccess: boolean;
    createPersonnelRoleFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface IInstitutionDepartmentPersonnelEditPageActions
    extends IRouterActions {
    clearPersonnelRole: PersonnelRoleActions.IPersonnelRoleClearActionCreator;
    loadPersonnelRole: PersonnelRoleActions.IPersonnelRoleLoadByIdActionCreator;
    savePersonnelRole: PersonnelRoleActions.IPersonnelRoleSaveActionCreator;
    createPersonnelRole: PersonnelRoleActions.IPersonnelRoleCreateActionCreator;

    clearInstitution: InstitutionActions.IInstitutionClearActionCreator;
    loadInstitution: InstitutionActions.IInstitutionLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type InstitutionDepartmentPersonnelEditPageProps =
    IInstitutionDepartmentPersonnelEditPageProps &
        IInstitutionDepartmentPersonnelEditPageActions;

const formName: string = "personnelRole";
const reduxFormName: string = "reduxForms.personnelRole";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
};

class InstitutionDepartmentPersonnelEditPage extends React.PureComponent<
    InstitutionDepartmentPersonnelEditPageProps,
    any
> {
    constructor(props: InstitutionDepartmentPersonnelEditPageProps) {
        super(props);

        this.clearPersonnelRole = this.clearPersonnelRole.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadPersonnelRole,
            createPersonnelRole,
            navigate,
            navigateReplace,
            personnelRoleId,
            departmentId,
            institutionId,
            loadInstitution,
            permissions,
            setDrawerItems,
            setBreadcrumbs
        } = this.props;
        

        setDrawerItems(InstitutionSubMenu(institutionId, permissions));

        if (personnelRoleId) {
            setBreadcrumbs(
                InstitutionDepartmentPersonnelBreadcrumbs(
                    institutionId,
                    departmentId,
                    personnelRoleId
                )
            );
            loadPersonnelRole(personnelRoleId);
        } else if (!personnelRoleId) {
            setBreadcrumbs(
                InstitutionCreateDepartmentPersonnelBreadcrumbs(
                    institutionId,
                    departmentId
                )
            );
            createPersonnelRole(
                null,
                null,
                institutionId,
                null,
                departmentId,
                null
            );
        }
        loadInstitution(institutionId);
    }

    componentWillReceiveProps(
        nextProps: InstitutionDepartmentPersonnelEditPageProps
    ) {}

    componentDidUpdate(
        prevProps: InstitutionDepartmentPersonnelEditPageProps,
        prevState
    ) {
        const {
            form,
            institutionId,
            departmentId,
            personnelRoleId,
            personnelRole,
            navigateReplace,
            loadPersonnelRole,
            loadInstitution,
            loadingPersonnelRole,
            loadPersonnelRoleSuccess,
            savingPersonnelRole,
            savePersonnelRoleSuccess,
            savePersonnelRoleFailure,
            createPersonnelRole,
            validationFailures,
            creatingPersonnelRole,
            createPersonnelRoleSuccess,
            navigate,
            institution,
            department,
            permissions,
            setDrawerItems,
            setBreadcrumbs,
            loadInstitutionFailure,
            loadPersonnelRoleFailure,
            loadInstitutionErrorCode,
            loadPersonnelRoleErrorCode,
        } = this.props;

        if (loadInstitutionFailure) {
            navigate(`/error/${loadInstitutionErrorCode}`);
        }
        if (loadPersonnelRoleFailure) {
            navigate(`/error/${loadPersonnelRoleErrorCode}`);
        }

        if (
            institutionId &&
            institution?.name &&
            departmentId &&
            department?.name &&
            personnelRoleId &&
            personnelRole?.personnel?.firstName &&
            personnelRole?.personnel?.lastName
        ) {
            setDrawerItems(InstitutionSubMenu(institutionId, permissions));
            setBreadcrumbs(
                InstitutionDepartmentPersonnelBreadcrumbs(
                    institutionId,
                    departmentId,
                    personnelRoleId,
                    institution.name,
                    department.name,
                    `${personnelRole.personnel.firstName} ${personnelRole.personnel.lastName}`
                )
            );
        } else if (!personnelRoleId) {
            setBreadcrumbs(
                InstitutionCreateDepartmentPersonnelBreadcrumbs(
                    institutionId,
                    departmentId,
                    institution?.name,
                    department?.name
                )
            );
        }

        if (institutionId && prevProps.institutionId != institutionId) {
            loadInstitution(institutionId);
        }

        if (personnelRoleId && prevProps.personnelRoleId != personnelRoleId) {
            loadPersonnelRole(personnelRoleId);
        } else if (!personnelRoleId && prevProps.personnelRoleId) {
            createPersonnelRole(
                null,
                null,
                institutionId,
                null,
                departmentId,
                null
            );
        }

        if (!loadingPersonnelRole && prevProps.loadingPersonnelRole) {
            if (loadPersonnelRoleSuccess) {
                this.loadForm();
            }
        }

        if (!savingPersonnelRole && prevProps.savingPersonnelRole) {
            if (savePersonnelRoleSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );

                    // toggleMessageModal();
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate(
                        "/institutions/" +
                            institutionId +
                            "/departments/" +
                            departmentId
                    );
                } else if (
                    !form.saveAndReturn &&
                    personnelRoleId &&
                    personnelRoleId > 0
                ) {
                    this.loadForm();
                } else if (
                    !form.saveAndReturn &&
                    !personnelRoleId &&
                    personnelRole &&
                    personnelRole.id > 0
                ) {
                    navigate(
                        "/institutions/" +
                            institutionId +
                            "/departments/" +
                            departmentId +
                            "/personnel/" +
                            personnelRole.id
                    );
                    this.loadForm();
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingPersonnelRole && prevProps.creatingPersonnelRole) {
            if (createPersonnelRoleSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUpdate(
        nextProps: InstitutionDepartmentPersonnelEditPageProps
    ) {}

    componentWillUnmount() {
        const { resetForm, loadForm } = this.props;

        this.clearPersonnelRole();
        loadForm(reduxFormName, initialPersonnelRoleState);
        resetForm(reduxFormName);
    }

    clearPersonnelRole() {
        this.props.clearPersonnelRole();
        this.props.clearInstitution();
    }

    showPersonnelRole(): boolean {
        const {
            loadingInstitution,
            loadingPersonnelRole,
            loadPersonnelRoleSuccess,
        } = this.props;

        if (
            !loadingInstitution &&
            !loadingPersonnelRole &&
            loadPersonnelRoleSuccess
        ) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingInstitution,
            loadingPersonnelRole,
            institution,
            institutionId,
        } = this.props;

        let id = institution ? institution.id : 0;
        let name = institution ? institution.name : "Institution";

        return (
            <RestrictedLayout
                subMenuTitle={institution ? institution.display : ""}
                subMenuItems={[]}
                loading={loadingInstitution || loadingPersonnelRole}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingPersonnelRole,
        } = this.props;

        let noPermissionToEditMessage = false;
        if (
            form.id &&
            form.id > 0 &&
            validationFailures &&
            validationFailures.filter((f) => f.errorCode == "PR-005").length > 0
        ) {
            noPermissionToEditMessage = true;
        }

        const formDisabled: boolean =
            savingPersonnelRole ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled) ||
            noPermissionToEditMessage;
        const formEdit: boolean =
            (formState && formState.formStatus == Dtos.FormStatus.Disabled) ||
            (form.id && form.id > 0);
        const formNew: boolean =
            (formState && formState.formStatus == Dtos.FormStatus.Disabled) ||
            !form.id ||
            form.id == 0;
        const departmentLookup: string =
            form.institutionId && form.institutionId > 0
                ? form.institutionId.toString() + "DepartmentId"
                : "DepartmentId";

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            trialId: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formEdit,
                inputProps: {
                    options: generateOptionsFromLookup(
                        findLookup("PersonnelRole", "TrialId", lookups),
                        form.trialId
                    ),
                    placeholder: "Institution Role",
                },
            },
            parent: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <div className="container-fluid">
                        {renderFormControls(
                            form,
                            "PersonnelRole",
                            {
                                institutionDisplay: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: TextFormInput,
                                    inputDisabled: true,
                                    groupClassName:
                                        form.institutionDisplay == ""
                                            ? "form-group-hide"
                                            : "form-group row pb-4 pt-4",
                                },
                                groupDisplay: {
                                    type: RegistrationComponent.RegistrationControl,
                                    inputType: TextFormInput,
                                    inputDisabled: true,
                                    groupClassName:
                                        form.groupDisplay == ""
                                            ? "form-group-hide"
                                            : "form-group row pb-4 pt-4",
                                },
                            },
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )}
                    </div>
                ),
            },
            personnelId: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formEdit,
                inputProps: {
                    options: generateOptionsFromLookup(
                        findLookup("PersonnelRole", "PersonnelId", lookups),
                        form.personnelId
                    ),
                },
            },
            roleId: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formEdit,
                inputProps: {
                    options: generateOptionsFromLookup(
                        findLookup("PersonnelRole", "RoleId", lookups),
                        form.roleId
                    ),
                },
            },
            departmentId: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: true,
                inputProps: {
                    options: generateOptionsFromLookup(
                        findLookup("PersonnelRole", departmentLookup, lookups),
                        form.departmentId
                    ),
                    placeholder: "No Department",
                },
            },
            dateStarted: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                validationMessageAbove: true,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active",
                },
                inputLabel: " ",
                changeAction: (model, value, form, parentModel) => {
                    changeForm(model, value);
                    if (value) {
                        changeForm(
                            reduxFormName + parentModel + ".dateCeased",
                            null
                        );
                    }
                },
            },
            dateCeased: {
                type: RegistrationComponent.RegistrationControl,
                inputType: DatePickerFormInputFabric,
                validationMessageAbove: true,
                inputDisabled: formDisabled,
                disabledFn: (form: Dtos.PersonnelRole, arrayKey: string) => {
                    if (form) {
                        if (form.active) {
                            return true;
                        }
                    }
                    return false;
                },
            },
        };

        return (
            <div>
                <h1>Personnel Role</h1>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, event) => this.handleOnSubmit(val)}
                    onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
                >
                    {noPermissionToEditMessage && (
                        <div className="alert alert-warning d-flex mt-2 mb-2">
                            <div className="mr-2">
                                <FontAwesomeIcon
                                    icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                    fixedWidth
                                />
                            </div>
                            <span>
                                You cannot edit a role that is higher than your
                                own.
                            </span>
                        </div>
                    )}
                    <div className="container-fluid">
                        {renderFormControls(
                            form,
                            "personnelRole",
                            formComponents,
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )}
                    </div>

                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>

                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={this.onCancel}
                            className="btn btn-primary mr-2"
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </Form>
            </div>
        );
    }

    renderErrorAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>;
    }

    handleOnSubmit(data: Dtos.PersonnelRole) {
        const { savePersonnelRole } = this.props;

        if (data) {
            let changes: Dtos.PersonnelRole = {} as Dtos.PersonnelRole;
            savePersonnelRole(Object.assign({ ...data }, changes));
        }
    }

    handleOnSubmitFailed(_data: Dtos.Institution) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onCancel() {
        const { institutionId, departmentId, navigate } = this.props;

        navigate(
            "/institutions/" + institutionId + "/departments/" + departmentId
        );
    }

    loadForm() {
        const { loadForm, personnelRole } = this.props;

        let extraData: Dtos.PersonnelRole = {} as Dtos.PersonnelRole;

        loadForm(reduxFormName, Object.assign({ ...personnelRole }, extraData));
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: InstitutionDepartmentPersonnelEditPageProps
): IInstitutionDepartmentPersonnelEditPageProps => {
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    let department: Dtos.Department | undefined = !(
        state.departments.formData instanceof Array
    )
        ? state.departments.formData
        : undefined;
    let personnelRole: Dtos.PersonnelRole | undefined = !(
        state.personnelRole.formData instanceof Array
    )
        ? state.personnelRole.formData
        : undefined;
    let institution: Dtos.Institution | undefined = !(
        state.institutions.formData instanceof Array
    )
        ? state.institutions.formData
        : undefined;

    return {
        match: ownProps.match,
        institutionId: ownProps.match
            ? ownProps.match.params.institutionId
            : undefined!,
        personnelRoleId:
            ownProps.match &&
            ownProps.match.params.personnelRoleId.toString() != "create"
                ? ownProps.match.params.personnelRoleId
                : undefined!,
        departmentId: ownProps.match
            ? ownProps.match.params.departmentId
            : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        personnelRole: personnelRole!,
        department: department!,
        institution: institution!,

        loadingPersonnelRole:
            state.personnelRole.loadState &&
            state.personnelRole.loadState.status == RequestState.Pending,
        loadPersonnelRoleSuccess:
            state.personnelRole.loadState &&
            state.personnelRole.loadState.status == RequestState.Success,
        loadPersonnelRoleFailure:
            state.personnelRole.loadState &&
            state.personnelRole.loadState.status == RequestState.Failure,
        loadPersonnelRoleErrorCode: state.personnelRole.loadState.errorCode,

        savingPersonnelRole:
            state.personnelRole.saveState &&
            state.personnelRole.saveState.status == RequestState.Pending,
        savePersonnelRoleSuccess:
            state.personnelRole.saveState &&
            state.personnelRole.saveState.status == RequestState.Success,
        savePersonnelRoleFailure:
            state.personnelRole.saveState &&
            state.personnelRole.saveState.status == RequestState.Failure,

        creatingPersonnelRole:
            state.personnelRole.createState &&
            state.personnelRole.createState.status == RequestState.Pending,
        createPersonnelRoleSuccess:
            state.personnelRole.createState &&
            state.personnelRole.createState.status == RequestState.Success,
        createPersonnelRoleFailure:
            state.personnelRole.createState &&
            state.personnelRole.createState.status == RequestState.Failure,

        loadingInstitution:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Pending,
        loadInstitutionSuccess:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Success,
        loadInstitutionFailure:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Failure,
        loadInstitutionErrorCode: state.institutions.loadState.errorCode,

        user: state.user.data,
        lookups: state.personnelRole.lookups,
        permissions: permissions,

        form: state.reduxForms.personnelRole,
        formState: state.personnelRole.formState,
        formProperties: state.personnelRole.formProperties,

        reduxFormState: state.reduxForms.formState.personnelRole,
        validationFailures: personnelRole
            ? state.personnelRole.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: InstitutionDepartmentPersonnelEditPageProps
): IInstitutionDepartmentPersonnelEditPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadPersonnelRole: bindActionCreators(
            PersonnelRoleActions.LoadPersonnelRoleById,
            dispatch
        ),
        clearPersonnelRole: bindActionCreators(
            PersonnelRoleActions.Clear,
            dispatch
        ),
        createPersonnelRole: bindActionCreators(
            PersonnelRoleActions.CreatePersonnelRole,
            dispatch
        ),
        savePersonnelRole: bindActionCreators(
            PersonnelRoleActions.SavePersonnelRole,
            dispatch
        ),

        loadInstitution: bindActionCreators(
            InstitutionActions.LoadInstitutionById,
            dispatch
        ),
        clearInstitution: bindActionCreators(
            InstitutionActions.Clear,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<
    IInstitutionDepartmentPersonnelEditPageParams,
    InstitutionDepartmentPersonnelEditPageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        InstitutionDepartmentPersonnelEditPage
    ) as unknown as ComponentType<InstitutionDepartmentPersonnelEditPageProps>
) as ComponentType<any>;
